import React from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { CheckCircle, Calendar, MoreHorizontal, Trash2, Edit, XCircle } from 'lucide-react';

interface GoalActionMenuProps {
  isCompleted: boolean;
  isOverdue: boolean;
  onComplete: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export default function GoalActionMenu({ isCompleted, isOverdue, onComplete, onEdit, onDelete }: GoalActionMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="h-8 w-8 p-0">
          <MoreHorizontal className="h-4 w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Goal Actions</DropdownMenuLabel>

        {!isCompleted && (
          <DropdownMenuItem onClick={onComplete} className="text-green-600">
            <CheckCircle className="mr-2 h-4 w-4" />
            Mark as Complete
          </DropdownMenuItem>
        )}

        {isCompleted && (
          <DropdownMenuItem onClick={onComplete} className="text-amber-600">
            <XCircle className="mr-2 h-4 w-4" />
            Mark as Incomplete
          </DropdownMenuItem>
        )}

        <DropdownMenuItem onClick={onEdit}>
          <Edit className="mr-2 h-4 w-4" />
          Edit Deadline
        </DropdownMenuItem>

        <DropdownMenuSeparator />

        <DropdownMenuItem onClick={onDelete} className="text-red-600">
          <Trash2 className="mr-2 h-4 w-4" />
          Delete Goal
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}